import React from 'react'
import "./index.css"
import TicketGuestDetail from '../TicketGuestDetail'

const GuestCard = ({ eventName, tickets,errors ,  openErrorEvent, handlePreCheckout , setErrorEvent, values, fieldRefs, eventIndex, setFieldValue, eventId, checkForCheckoutPage, eventRequirements, setFieldError }) => {
    return (
        <div className='checkout_guest_card' >
            <div className='guestCard_eventName' >
                <h3>{eventName}</h3>
            </div>
            <div className='guestCard_ticket' >
                {
                    tickets?.map(({ ticket, guests }, index) => {
                        return <TicketGuestDetail handlePreCheckout={handlePreCheckout} setErrorEvent={setErrorEvent} openErrorEvent={openErrorEvent} fieldRefs={fieldRefs} checkForCheckoutPage={checkForCheckoutPage} setFieldError={setFieldError} eventId={eventId} eventRequirements={eventRequirements} setFieldValue={setFieldValue} item={ticket} guestDetail={guests} key={index} eventIndex={eventIndex} ticketIndex={index} values={values} guestQuantity={ticket?.quantity} errors={errors} />
                    })
                }
            </div>
        </div>
    )
}

export default GuestCard